var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { str_replace } from '../../../utils/helper/helper_string';
export class Cleaner {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get wordTask() {
        return this.parent.wordTask;
    }
    get rawString() {
        return '';
    }
    get handledCase() {
        if (this.wordTask.isCaseSensitive)
            return this.rawString;
        return this.rawString.toLowerCase();
    }
    get handledTrim() {
        return this.handledCase.trim();
    }
    get handledApostophe() {
        return str_replace(['´', '`', '’'], "'", this.handledTrim);
    }
    get handledIgnorePlaceholders() {
        return this.handledApostophe.split('_')[0].split(' ')[0]; // Input mask Placeholders
    }
    /*
    UTF-8 Space characters:
    static $whitespace = array(
      "SPACE" => "\x20",
      "NO-BREAK SPACE" => "\xc2\xa0",
      "OGHAM SPACE MARK" => "\xe1\x9a\x80",
      "EN QUAD" => "\xe2\x80\x80",
      "EM QUAD" => "\xe2\x80\x81",
      "EN SPACE" => "\xe2\x80\x82",
      "EM SPACE" => "\xe2\x80\x83",
      "THREE-PER-EM SPACE" => "\xe2\x80\x84",
      "FOUR-PER-EM SPACE" => "\xe2\x80\x85",
      "SIX-PER-EM SPACE" => "\xe2\x80\x86",
      "FIGURE SPACE" => "\xe2\x80\x87",
      "PUNCTUATION SPACE" => "\xe2\x80\x88",
      "THIN SPACE" => "\xe2\x80\x89",
      "HAIR SPACE" => "\xe2\x80\x8a",
      "ZERO WIDTH SPACE" => "\xe2\x80\x8b",
      "NARROW NO-BREAK SPACE" => "\xe2\x80\xaf",
      "MEDIUM MATHEMATICAL SPACE" => "\xe2\x81\x9f",
  
  
     */
    get handledIgnoreCharacters() {
        // ignore thin space and narrow non breaking space (used in input masks)
        return str_replace([' ', ' '], '', this.handledIgnorePlaceholders); // Input mask Placeholders
    }
    get handledNumberSpaces() {
        if (this.wordTask.wordTaskExpect.isExpectingNumber) {
            return str_replace([' '], '', this.handledIgnoreCharacters);
        }
        return this.handledIgnoreCharacters;
    }
    /*
      get handledTextMask(): string {
        const {activeInputMask} = this.wordTask.wordTaskMask;
     if(activeInputMask.length === 0)  return this.handledNumberSpaces;
    
    
       if(activeInputMask === InputMaskType.EuroGanz){
         return this.handledNumberSpaces.split('€')[0];
     }
        return this.handledNumberSpaces.split('ct')[0];
      }
    */
    get cleanedString() {
        return this.handledNumberSpaces;
    }
}
__decorate([
    computed
], Cleaner.prototype, "cleanedString", null);
/*
        if (jQuery.isNumeric(str_replace([' ', '.'], '', first)) || jQuery.isNumeric(str_replace([' ', '.'], '', second))) {
            first = str_replace([' ', '.'], '', first);
            second = str_replace([' ', '.'], '', second);
        }
      */
